
const GeocoderService = {  
	// Compatibilités globales pour les CSV
	latKeys: ["lat", "latitude", "y"],
	lngKeys: ["lng", "longitude", "lon", "long", "x"],
	parcelKeys: ["idpar", "id_parcelle", "idu", "parcelles", "parcelle"],
	adressKeys: ["adress", "adresse"],
	postcodeKeys: ["postcode", "code postal", "cp", "code_postal"],
	cityKeys: ["city", "ville", "commune", "com", "nom_commune"],
	citycodeKeys: ["citycode", "code insee", "insee", "code ville"],
	
    getLayerJsonfromdata(element){
		let jsonreponse = {};
		if(element?.result?.features){
			if(element.result.features.length == 1 && element.result.features[0]?.geometry?.type == 'Point'){
				let feature = element.result.features[0];				
				jsonreponse.geom = feature.geometry;
				jsonreponse.titre = feature.properties?.label || feature.properties?.titre || feature.properties?.id_par || feature.properties?.idu || feature.properties?.name ||  feature.properties?.adresse || feature.properties?.id || feature.properties?.titretmp || "";				
				jsonreponse.observation = feature.properties?.observation || "";				
						
			} else {
				const geom = L.geoJSON(element.result, {
					onEachFeature: (resfeature, layer) => {
						const feature = this.normalizeToMulti(resfeature);
						jsonreponse.geom = feature.geometry;
						jsonreponse.titre = feature.properties?.label || feature.properties?.titre || feature.properties?.id_par || feature.properties?.idu ||feature.properties?.name || feature.properties?.adresse || feature.properties?.id || feature.properties?.titretmp || "";				
						jsonreponse.observation = feature.properties?.observation || "";
					}
				});
			}
            return jsonreponse;
		} else {
			console.error('getLayerJsonfromdata: no features');
			return;
		}
	},

	normalizeToMulti(feature) {
		let geom = feature.geometry;
	
		// Forcer Polygon → MultiPolygon
		if (geom.type === "Polygon") {
			geom = {
				type: "MultiPolygon",
				coordinates: [geom.coordinates]
			};
		}
	
		// Forcer LineString → MultiLineString
		if (geom.type === "LineString") {
			geom = {
				type: "MultiLineString",
				coordinates: [geom.coordinates]
			};
		}
	
		return {
			...feature,
			geometry: geom
		};
	},

	async getGeojsongpkg(urlApi,userId,file) {		
		const formData = new FormData();
		formData.append('file', file);
		try {
			const response = await fetch(`${urlApi}${userId}/collection/getjsongpkg`, {
				method: 'POST',
				body: formData
			});
			if (!response.ok) {
				return [];
			}
			let geojson = await response.json();
			
			const meta = {
				totalRows: geojson.features.length,  
				importedRows: geojson.features.length,
				errorRows: 0 
			};
			geojson.meta = meta;
			return geojson;
		} catch (err) {
			return [];
		}
	},

	normalizeHeader(h) {
		return h.trim().toLowerCase().replace(/[_ ]/g, "");
	},

	// Détection si un CSV contient des points
	detectCsvType(data) {
		if (!data || data.length < 2) return null; // pas assez de données

		// Normalisation : minuscule + suppression espaces et _
		const headersNormalized  = data[0].map(h => this.normalizeHeader(h));
		
		// Vérifier les points
		const hasLat = headersNormalized.some(h => this.latKeys.some(k => this.normalizeHeader(k) === h));
		const hasLng = headersNormalized.some(h => this.lngKeys.some(k => this.normalizeHeader(k) === h));
	
		// Vérifier les parcelles
		const hasParcel = headersNormalized.some(h => this.parcelKeys.some(k => this.normalizeHeader(k) === h));
	
		// Vérifier les adresses
		const hasAdress = headersNormalized.some(h => this.adressKeys.some(k => this.normalizeHeader(k) === h));
		const hasPostcode = headersNormalized.some(h => this.postcodeKeys.some(k => this.normalizeHeader(k) === h));
		const hasCity = headersNormalized.some(h => this.cityKeys.some(k => this.normalizeHeader(k) === h));
		const hasCitycode = headersNormalized.some(h => this.citycodeKeys.some(k => this.normalizeHeader(k) === h));
		
		if (hasLat && hasLng) return "points";
		if (hasParcel) return "parcelles";
		const hasAddressMinimum = hasAdress || (hasPostcode && hasCity);
		if (hasAddressMinimum) return "adresses";
		return null;
	},
  
  	parsePointsCsv(data) {
		const headers = data[0].map(h => h.trim().toLowerCase());
		const latIndex = headers.findIndex(h => this.latKeys.includes(h));
		const lngIndex = headers.findIndex(h => this.lngKeys.includes(h));

		const result = [];

		for (let i = 1; i < data.length; i++) {
			const row = data[i];
			if (!row[latIndex] || !row[lngIndex]) continue;
			const lat = parseFloat(row[latIndex]);
			const lng = parseFloat(row[lngIndex]);
			if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
				continue;
			}
			// On transforme toute la ligne en propriétés
			const properties = {};
			headers.forEach((h, idx) => {
				properties[h] = row[idx];
			});
			properties['titretmp'] = 'mon point '+i;
			// Création d'un objet GeoJSON COMPLET pour cette ligne
			const geojsonFeature = {
				type: "Feature",
				geometry: {
				type: "Point",
				coordinates: [
					parseFloat(row[lngIndex]),
					parseFloat(row[latIndex])
				]
				},
				properties
			};

			// On pousse UNE FeatureCollection par ligne (comme ton code original)
			result.push(geojsonFeature);
		}

		const resfinal = {
			type: "FeatureCollection",
			features: result,
			meta: {
				totalRows: data.length - 1,      
				importedRows: result.length,     
				errorRows: (data.length - 1) - result.length
			  }
		};

		return resfinal;
	},
  

	async parseParcellesCsv (data,pciUri){
		const headers = data[0].map(h => h.trim().toLowerCase());		
		// Trouver l'index de la colonne idpar
		const idparIndex = headers.findIndex(h => this.parcelKeys.includes(h));
		if (idparIndex < 0) return null;	
		const promises  = [];	
		// Boucle sur chaque ligne du CSV
		for (let i = 1; i < data.length; i++) {
			const row = data[i];
			if (row.length === 0 || !row[idparIndex]) continue;
	
			const idpar = row[idparIndex];	
			const source = {};
			headers.forEach((h, idx) => {
				source[h] = row[idx];
			});
	
			promises.push(
				this.fetchParcelle(idpar,pciUri).then(result => ({ source, result }))
			);
		}

		return await Promise.all(promises);
	
	},
  
	async fetchParcelle(idpar,pciUri){
		const url = `${pciUri}parcelle/${idpar}?skipGeometry=false`;
		try {
			const response = await fetch(url);
			if (!response.ok) {
				console.error(`fetchParcelle: HTTP ${response.status} for ${idpar}`);
				return null;
			}
			
			const contentType = response.headers.get("content-type") || "";
			// Accepter plusieurs types de content-type pour la compatibilité
			const isGeoJson = 	contentType.includes("geo+json") || 
								contentType.includes("application/json") ||
								contentType.includes("json");
			
			if (isGeoJson) {
				const data = await response.json();
				// Vérifier que c'est bien un FeatureCollection
				if (data && data.type === "FeatureCollection" && data.features) {
					return data;
				} else {
					console.error(`fetchParcelle: Invalid GeoJSON format for ${idpar}`, data);
					return null;
				}
			} else {
				console.error(`fetchParcelle: Unexpected content-type "${contentType}" for ${idpar}`);
				return null;
			}
		} catch (err) {
			console.error(`fetchParcelle error for ${idpar}:`, err);
			return null;
		}
	},
	
	async parseAdressesCsv(data,banUri) {
		if (!data || data.length < 2) return null;
	
		const headers = data[0].map(h => h.trim().toLowerCase());	
	
		// Index des colonnes
        const addressIndex = headers.findIndex(h => this.adressKeys.includes(h));
        const postcodeIndex = headers.findIndex(h => this.postcodeKeys.includes(h));
        const cityIndex = headers.findIndex(h => this.cityKeys.includes(h));
        const citycodeIndex = headers.findIndex(h => this.citycodeKeys.includes(h));

	
		// Vérifier présence minimale pour BAN
		const hasMinimum = addressIndex >= 0 || (postcodeIndex >= 0 && cityIndex >= 0);
		if (!hasMinimum) {
			console.warn("Aucune colonne minimale compatible pour BAN détectée");
			return null;
		}

	
		// Générer un nouveau CSV avec les colonnes BAN officielles
		const banHeaders = ["adresse","postcode","city","citycode"];
		const csvRows = [banHeaders];
	
		const sourceRows = [];
		for (let i = 1; i < data.length; i++) {
			const row = data[i];
			if (row.length === 0) continue;
	
			const source = {};
			headers.forEach((h, idx) => source[h] = row[idx]);
	
			sourceRows.push(source);

			const newRow = [
				addressIndex >= 0 ? row[addressIndex] : "",
				postcodeIndex >= 0 ? row[postcodeIndex] : "",
				cityIndex >= 0 ? row[cityIndex] : "",
				citycodeIndex >= 0 ? row[citycodeIndex] : ""
			];
	
			csvRows.push(newRow);
		}
	
		// Convertir le tableau en CSV texte
		const csvContent = csvRows.map(r => r.map(cell => `"${cell.replace(/"/g, '""')}"`).join(";")).join("\n");
	

		// Créer un Blob pour envoyer à l'API
		const fileBlob = new Blob([csvContent], { type: 'text/csv' });
	
		// Préparer FormData
		const formData = new FormData();
		formData.append("data", fileBlob, "ban_temp.csv");
	
		try {
			const response = await fetch(`${banUri}/search/csv`, {
				method: "POST",
				body: formData
			});
	
			if (!response.ok) {
				console.error("Erreur API BAN :", response.statusText);
				return null;
			}
	
			const contentType = response.headers.get("content-type");
			if (!contentType || !contentType.includes("text/csv")) {
				console.error("Réponse API BAN invalide");
				return null;
			}
	
			const csvText = await response.text();
	
			// Parser le CSV résultat de l'API
			const parsedResult = Papa.parse(csvText, { delimiter: ';', skipEmptyLines: true });
			const resultData = parsedResult.data;
			if (!resultData || resultData.length < 2) return null;
	
			// Convertir en GeoJSON
			const geojsonFeatures = [];
			const resultHeaders = resultData[0].map(h => h.trim().toLowerCase());

			const latIndex = resultHeaders.findIndex(h => this.latKeys.includes(h));
			const lngIndex = resultHeaders.findIndex(h => this.lngKeys.includes(h));
	
			for (let i = 1; i < resultData.length; i++) {
				const row = resultData[i];
				const source = sourceRows[i - 1];
				if (!row[latIndex] || !row[lngIndex]) continue;
	
				const properties = {
					...source
				};
				resultHeaders.forEach((h, idx) => properties[h] = row[idx]);
	
				geojsonFeatures.push({
					type: "Feature",
					geometry: {
						type: "Point",
						coordinates: [parseFloat(row[lngIndex]), parseFloat(row[latIndex])]
					},
					properties
				});
			}
			return {
				type: "FeatureCollection",
				features: geojsonFeatures,
				meta: {
					totalRows: data.length - 1,  
					importedRows: geojsonFeatures.length,
					errorRows: (data.length - 1) - geojsonFeatures.length  
				}
			};
	
		} catch (err) {
			console.error("Erreur fetch BAN :", err);
			return null;
		}
	},
	

}

export default GeocoderService;